import { createContext } from 'react';
import { MenuItem } from '@nx-frontend/shared/types';

interface TopbarContextValue {
  noteMenuItem: MenuItem | null;
}

export const TopbarContext = createContext<TopbarContextValue | null>(null);
